let currentAppConfig = {};

export const initConfig = (appConfigKey) => {
  currentAppConfig = appConfig[appConfigKey] || appConfig.default;

  return currentAppConfig;
};

export const getAppConfig = () => currentAppConfig;

const appConfig = {
  default: {
    subscriptionPage: "https://app.spectrebowling.com/registration",
    apiServer: "https://app.spectrebowling.com/api/",
    importServer: "https://app.spectrebowling.com/api/",
    fileServer: "https://app.spectrebowling.com/files/",
    appUrl: "https://app.spectrebowling.com/",
    resettingPage: "https://app.spectrebowling.com/resetting/request",
    commSocket: "wss://app.spectrebowling.com/comm",
    bowlingDatabase: "https://api.bowlingdatabase.com",
    bowlingDatabaseKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImJhNzg4MzFhLTM4NTktNDdmYy1iYzhlLWM3ZjA1MWU4YmUwOCIsInVzZXJuYW1lIjoidGVzdCIsInBsYWluX3Bhc3N3b3JkIjoidGVzdDEyM25wbSIsInBhc3N3b3JkIjoiMWtKTWxsNWNpb1VCQkFZOXN0djFSMFlidWNpMUorMXlrdkJYbWJmK1JuYzR5dEZqeWFMbjRxV0dCQTJDTVBBV1RlZlZVakJ1N3pDVWJ0U2JGbXIwWFE9PSIsImFjdGl2ZSI6dHJ1ZSwidXBkYXRlZF9hdCI6IjIwMjQtMDMtMDZUMjA6NTA6MzEuNjU4WiIsImNyZWF0ZWRfYXQiOiIyMDI0LTAzLTA2VDIwOjUwOjMxLjY1OFoiLCJpYXQiOjE3MDk3NTgyMzJ9.tNqDHL-0jSZadKMsgJGvPNIsKfBYr-hUJzWECoE4XNM",
    paddle_client_side_token: "test_b117c20d613e23453475b63df53",
    payment_gateway: "PADDLE",
    stripe_key:
      "pk_test_51Ko7MgFCBxVexLHV0cFHcX3fACeMsVLhyugiU492Dycav2qkmBcm0EYO9BXOOY6ytuiHB3mxWZZMf6D6kp6ZRhqO00D7IbEVBz",
    isSandbox: true,
  },
  "cloud.spectrebowling.com": {
    subscriptionPage: "https://app.spectrebowling.com/registration",
    apiServer: "https://app.spectrebowling.com/api/",
    importServer: "https://app.spectrebowling.com/api/",
    fileServer: "https://app.spectrebowling.com/files/",
    appUrl: "https://app.spectrebowling.com/",
    resettingPage: "https://app.spectrebowling.com/resetting/request",
    commSocket: "wss://app.spectrebowling.com/comm",
    bowlingDatabase: "https://api.bowlingdatabase.com",
    bowlingDatabaseKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImJhNzg4MzFhLTM4NTktNDdmYy1iYzhlLWM3ZjA1MWU4YmUwOCIsInVzZXJuYW1lIjoidGVzdCIsInBsYWluX3Bhc3N3b3JkIjoidGVzdDEyM25wbSIsInBhc3N3b3JkIjoiMWtKTWxsNWNpb1VCQkFZOXN0djFSMFlidWNpMUorMXlrdkJYbWJmK1JuYzR5dEZqeWFMbjRxV0dCQTJDTVBBV1RlZlZVakJ1N3pDVWJ0U2JGbXIwWFE9PSIsImFjdGl2ZSI6dHJ1ZSwidXBkYXRlZF9hdCI6IjIwMjQtMDMtMDZUMjA6NTA6MzEuNjU4WiIsImNyZWF0ZWRfYXQiOiIyMDI0LTAzLTA2VDIwOjUwOjMxLjY1OFoiLCJpYXQiOjE3MDk3NTgyMzJ9.tNqDHL-0jSZadKMsgJGvPNIsKfBYr-hUJzWECoE4XNM",
    paddle_client_side_token: "live_6d0398373c76a4496d29324a0c0",
    payment_gateway: "PADDLE",
    stripe_key:
      "pk_live_51Ko7MgFCBxVexLHVzLHpasuDBNoOolPlV1dnm7e8NB9XXTG6xtzZnmJqW2yVPQpdbzim33p6lGMQOSfAL1K9qAGH00BJiOPsCU",
    isSandbox: false,
  },
  "v3.spectrebowling.com": {
    // subscriptionPage: "https://dev.spectrebowling.com/registration",
    // apiServer: "https://dev.spectrebowling.com/api/",
    // importServer: "https://dev.spectrebowling.com/api/",
    // fileServer: "https://dev.spectrebowling.com/files/",
    // appUrl: "https://dev.spectrebowling.com/",
    // resettingPage: "https://dev.spectrebowling.com/resetting/request",
    // commSocket: "wss://dev.spectrebowling.com/comm",
    subscriptionPage: "https://app.spectrebowling.com/registration",
    apiServer: "https://app.spectrebowling.com/api/",
    importServer: "https://app.spectrebowling.com/api/",
    fileServer: "https://app.spectrebowling.com/files/",
    appUrl: "https://app.spectrebowling.com/",
    resettingPage: "https://app.spectrebowling.com/resetting/request",
    commSocket: "wss://app.spectrebowling.com/comm",
    bowlingDatabase: "https://api.bowlingdatabase.com",
    bowlingDatabaseKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImJhNzg4MzFhLTM4NTktNDdmYy1iYzhlLWM3ZjA1MWU4YmUwOCIsInVzZXJuYW1lIjoidGVzdCIsInBsYWluX3Bhc3N3b3JkIjoidGVzdDEyM25wbSIsInBhc3N3b3JkIjoiMWtKTWxsNWNpb1VCQkFZOXN0djFSMFlidWNpMUorMXlrdkJYbWJmK1JuYzR5dEZqeWFMbjRxV0dCQTJDTVBBV1RlZlZVakJ1N3pDVWJ0U2JGbXIwWFE9PSIsImFjdGl2ZSI6dHJ1ZSwidXBkYXRlZF9hdCI6IjIwMjQtMDMtMDZUMjA6NTA6MzEuNjU4WiIsImNyZWF0ZWRfYXQiOiIyMDI0LTAzLTA2VDIwOjUwOjMxLjY1OFoiLCJpYXQiOjE3MDk3NTgyMzJ9.tNqDHL-0jSZadKMsgJGvPNIsKfBYr-hUJzWECoE4XNM",
    paddle_client_side_token: "test_b117c20d613e23453475b63df53",
    payment_gateway: "PADDLE",
    stripe_key:
      "pk_test_51Ko7MgFCBxVexLHV0cFHcX3fACeMsVLhyugiU492Dycav2qkmBcm0EYO9BXOOY6ytuiHB3mxWZZMf6D6kp6ZRhqO00D7IbEVBz",
    isSandbox: true,
  },
  local: {
    subscriptionPage: "https://dev.spectrebowling.com/registration",
    apiServer: "https://dev.spectrebowling.com/api/",
    importServer: "https://dev.spectrebowling.com/api/",
    fileServer: "https://dev.spectrebowling.com/files/",
    appUrl: "https://dev.spectrebowling.com/",
    resettingPage: "https://dev.spectrebowling.com/resetting/request",
    commSocket: "wss://dev.spectrebowling.com/comm",
    // subscriptionPage: "https://app.spectrebowling.com/registration",
    // apiServer: "https://app.spectrebowling.com/api/",
    // importServer: "https://app.spectrebowling.com/api/",
    // fileServer: "https://app.spectrebowling.com/files/",
    // appUrl: "https://app.spectrebowling.com/",
    // resettingPage: "https://app.spectrebowling.com/resetting/request",
    // commSocket: "wss://app.spectrebowling.com/comm",
    bowlingDatabase: "https://api.bowlingdatabase.com",
    bowlingDatabaseKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImJhNzg4MzFhLTM4NTktNDdmYy1iYzhlLWM3ZjA1MWU4YmUwOCIsInVzZXJuYW1lIjoidGVzdCIsInBsYWluX3Bhc3N3b3JkIjoidGVzdDEyM25wbSIsInBhc3N3b3JkIjoiMWtKTWxsNWNpb1VCQkFZOXN0djFSMFlidWNpMUorMXlrdkJYbWJmK1JuYzR5dEZqeWFMbjRxV0dCQTJDTVBBV1RlZlZVakJ1N3pDVWJ0U2JGbXIwWFE9PSIsImFjdGl2ZSI6dHJ1ZSwidXBkYXRlZF9hdCI6IjIwMjQtMDMtMDZUMjA6NTA6MzEuNjU4WiIsImNyZWF0ZWRfYXQiOiIyMDI0LTAzLTA2VDIwOjUwOjMxLjY1OFoiLCJpYXQiOjE3MDk3NTgyMzJ9.tNqDHL-0jSZadKMsgJGvPNIsKfBYr-hUJzWECoE4XNM",
    paddle_client_side_token: "test_b117c20d613e23453475b63df53",
    payment_gateway: "PADDLE",
    stripe_key:
      "pk_test_51Ko7MgFCBxVexLHV0cFHcX3fACeMsVLhyugiU492Dycav2qkmBcm0EYO9BXOOY6ytuiHB3mxWZZMf6D6kp6ZRhqO00D7IbEVBz",
    isSandbox: true,
  },
};
